import { render, staticRenderFns } from "./DocButton.vue?vue&type=template&id=66784734&lang=pug&"
import script from "./DocButton.vue?vue&type=script&lang=ts&"
export * from "./DocButton.vue?vue&type=script&lang=ts&"
import style0 from "./DocButton.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports